import { type ReactNode, useState } from "react";
import type { VerifyAccountStep } from "./verifyAccountSteps";
import { VerifyAccountStepContext } from "./VerifyAccountStepContext";

function VerifyAccountStepProvider({
	children,
	initialStepFromState,
}: {
	children: ReactNode;
	initialStepFromState: VerifyAccountStep | null;
}) {
	const [step, setStepState] = useState<VerifyAccountStep>(
		initialStepFromState ?? "pin",
	);

	return (
		<VerifyAccountStepContext.Provider value={{ step, setStep: setStepState }}>
			{children}
		</VerifyAccountStepContext.Provider>
	);
}

export { VerifyAccountStepProvider };
